<div class="product-flags-container">
  @for (flag of productFlags; track flag) {
    <app-product-flag-item [productFlag]="flag"></app-product-flag-item>
  }
</div>
